// Constants
import {
  ERROR_COMPONENT_DECLINED_IMAGE,
  ERROR_COMPONENT_DEFAULT_IMAGE,
  ERROR_COMPONENT_STATES_IMAGE,
} from './constants/error.configurations.constants';
import { VARIANTS } from '@openbank/ziniaweb-ui-components';
// Enumerations
import { AppStatesEnumeration } from 'enumerations/app-states.enumeration';
// Translations
import { DESCRIPTIONS, TITLES } from '../translations/error.translations';
import {
  ONBOARDING_FLOW_DESCRIPTIONS,
  ONBOARDING_FLOW_TITLES,
} from './translations/error.configurations.translations';
// Types
import type { ErrorType } from '../types/error.type';
// Utils
import {
  isContractError,
  isDeclinedOnboardingError,
  isKycError,
  isOnboardingFlowError,
  isPaymentError,
  isProofIncomeError,
  isUploadIdError,
} from '../utils/error.utils';

const getErrorImage = (error: ErrorType['error']): string => {
  switch (true) {
    case isDeclinedOnboardingError(error):
      return ERROR_COMPONENT_DECLINED_IMAGE;
    case isOnboardingFlowError(error):
      return ERROR_COMPONENT_STATES_IMAGE;
    default:
      return ERROR_COMPONENT_DEFAULT_IMAGE;
  }
};

const getErrorTitle = (error: ErrorType['error']): string => {
  switch (true) {
    case isContractError(error):
      return ONBOARDING_FLOW_TITLES[AppStatesEnumeration.CHECKOUT_SIGNING];
    case isKycError(error):
      return ONBOARDING_FLOW_TITLES[AppStatesEnumeration.CHECKOUT_IDENTIFICATION];
    case isPaymentError(error):
      return ONBOARDING_FLOW_TITLES[AppStatesEnumeration.CHECKOUT_DOWNPAYMENT];
    case isProofIncomeError(error):
      return ONBOARDING_FLOW_TITLES[AppStatesEnumeration.CHECKOUT_INCOME];
    case isUploadIdError(error):
      return ONBOARDING_FLOW_TITLES[AppStatesEnumeration.CHECKOUT_PENDING];
    default:
      return TITLES[error];
  }
};

const getErrorDescription = (error: ErrorType['error']): string => {
  switch (true) {
    case isContractError(error):
      return ONBOARDING_FLOW_DESCRIPTIONS[AppStatesEnumeration.CHECKOUT_SIGNING];
    case isKycError(error):
      return ONBOARDING_FLOW_DESCRIPTIONS[AppStatesEnumeration.CHECKOUT_IDENTIFICATION];
    case isPaymentError(error):
      return ONBOARDING_FLOW_DESCRIPTIONS[AppStatesEnumeration.CHECKOUT_DOWNPAYMENT];
    case isProofIncomeError(error):
      return ONBOARDING_FLOW_DESCRIPTIONS[AppStatesEnumeration.CHECKOUT_INCOME];
    case isUploadIdError(error):
      return ONBOARDING_FLOW_DESCRIPTIONS[AppStatesEnumeration.CHECKOUT_PENDING];
    default:
      return DESCRIPTIONS[error];
  }
};

const getFooterVariant = (
  error: ErrorType['error']
):
  | typeof VARIANTS.FooterVariantsType.ACTION_BUTTONS
  | typeof VARIANTS.FooterVariantsType.ONE_ACTION =>
  isOnboardingFlowError(error)
    ? VARIANTS.FooterVariantsType.ACTION_BUTTONS
    : VARIANTS.FooterVariantsType.ONE_ACTION;

export { getErrorDescription, getErrorImage, getErrorTitle, getFooterVariant };
